import anime from '../libs/anime'
import globalVar from '../utils/globalVar'

class ScrollTo {
  constructor() {
    let cache = {};
    let initFunc = () => {
      initCache();
      registerEvents();
    }

    let initCache = () => {
      cache.btnScroll = document.querySelectorAll('.scrollto');
    };

    let registerEvents = () => {
      for (let i = 0; i < cache.btnScroll.length; i++) {
        cache.btnScroll[i].addEventListener("click", scrollTo);
      }
    };

    function scrollTo(e) {
        const trigger = this;
        document.querySelector('body').classList.add('scroll');
        e.preventDefault();
        var target = document.querySelector(trigger.getAttribute("href"));
        anime({
            targets: globalVar.scrollElement,
            scrollTop: (globalVar.scrollElement.scrollTop+target.getBoundingClientRect().top),
            duration: 600,
            easing: 'easeOutQuad',
            complete: function () {
            document.querySelector('body').classList.remove('scroll');
            }
        });
    }

    initFunc();
  };
}
export { ScrollTo }
